import { render, staticRenderFns } from "./TransactionsCustomersPaymentsList.vue?vue&type=template&id=db60af1a&"
import script from "./TransactionsCustomersPaymentsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsCustomersPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports